/**
 * @fileoverview Fallback UI for chunk load failures.
 * Shown by RouteErrorBoundary when a ChunkLoadError is caught,
 * giving the user a clear recovery path instead of a blank screen.
 *
 * Uses high-contrast styling so it's always visible regardless of theme.
 */

import { RefreshCw, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function ChunkErrorFallback() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center p-6 text-center bg-background text-foreground">
      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
        <RefreshCw className="w-7 h-7 text-primary" />
      </div>

      <h2 className="text-xl font-semibold mb-2">
        App updated
      </h2>

      <p className="text-sm text-muted-foreground mb-6 max-w-xs">
        A new version is available. Reload to continue where you left off.
      </p>

      <div className="flex items-center gap-3">
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            window.history.replaceState(null, '', '/');
            window.location.reload();
          }}
          className="gap-2"
        >
          <Home className="w-4 h-4" />
          Go Home
        </Button>

        <Button
          size="sm"
          onClick={() => window.location.reload()}
          className="gap-2"
        >
          <RefreshCw className="w-4 h-4" />
          Reload
        </Button>
      </div>
    </div>
  );
}
